import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import analyticsService, { AmplitudeEventData, AnalyticsEvent } from 'services/AnalyticsService';
import { MuiBox } from 'theme/material-ui';
import Typography from 'components/UI/Typography';
import Spacer from 'components/UI/Layout/Spacer';
import { FontSize, FontWeight } from 'modules/styles/variables';
import { PreRegistrationFacilitySelector } from 'store/preRegistration/selectors';
import {
  currentLocationPathNameSelector,
  previousLocationPathNameSelector
} from 'store/router/selectors';
import { FacilityLocation } from 'store/preRegistration/types';
import { RootState } from 'store/types';
import { Warning } from 'components/Error/common';

interface Props {
  facilityLocation: FacilityLocation | undefined;
  referringUrl: string;
  currentUrl: string;
}

export const BadAttemptsModal = ({ facilityLocation, currentUrl, referringUrl }: Props) => {
  useEffect(() => {
    const amplitudeEventData: AmplitudeEventData = {
      currentUrl,
      referringUrl,
      /* eslint-disable-next-line @typescript-eslint/camelcase */
      form_location: facilityLocation?.name || '',
      /* eslint-disable-next-line @typescript-eslint/camelcase */
      form_detail_additional_info: 'Too many bad attempts'
    };
    analyticsService.logEvent(AnalyticsEvent.HospitalFormAuthFailed, amplitudeEventData);
  }, []);

  return (
    <MuiBox display="flex" alignItems="center" justifyContent="center" height="100%">
      <MuiBox display="flex" flexDirection="column" height="100%" alignItems="center">
        <MuiBox p={8} display="flex" flexDirection="column" alignItems="center">
          <Warning large />
          <Spacer spacing="xLarge" />
          <Typography textAlign="center" fontSize={FontSize.heading} fontWeight={FontWeight.bold}>
            Too many bad attempts
          </Typography>
          <Spacer spacing="large" />
          <Typography textAlign="center">
            You can complete your pre-visit forms when you arrive at your appointment.
          </Typography>
        </MuiBox>
      </MuiBox>
    </MuiBox>
  );
};

const mapStateToProps = (state: RootState) => ({
  facilityLocation: PreRegistrationFacilitySelector(state),
  currentUrl: currentLocationPathNameSelector(state),
  referringUrl: previousLocationPathNameSelector(state)
});

export default connect(mapStateToProps)(BadAttemptsModal);
